/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    clearCategory: {
        id: 'quoteandbind.RecVehLine.templates.Occupation.clearCategory',
        defaultMessage: 'Clear Category'
    },
    industryCodeSearch: {
        id: 'quoteandbind.RecVehLine.templates.Occupation.Violation Category Code Search',
        defaultMessage: 'Violation Category Code Search'
    },
    Code: {
        id: 'quoteandbind.RecVehLine.templates.Occupation.Code',
        defaultMessage: 'Code'
    },
    search: {
        id: 'quoteandbind.RecVehLine.templates.Occupation.Search',
        defaultMessage: 'Search'
    },
    reset: {
        id: 'quoteandbind.RecVehLine.templates.Occupation.Reset',
        defaultMessage: 'Reset'
    },
    cancel: {
        id: 'quoteandbind.RecVehLine.templates.Occupation.Cancel',
        defaultMessage: 'Cancel'
    },
    searchResults: {
        id: 'quoteandbind.RecVehLine.templates.Occupation.Search Results',
        defaultMessage: 'Search Results'
    },
    select: {
        id: 'quoteandbind.RecVehLine.templates.Occupation.Select',
        defaultMessage: 'Select'
    },
    industryCode: {
        id: 'quoteandbind.RecVehLine.templates.Occupation.Violation Category Code',
        defaultMessage: 'Violation Category Code'
    },
    descriptionOfOccupancy: {
        id: 'quoteandbind.RecVehLine.templates.Occupation.Description Of Occupancy',
        defaultMessage: 'Description Of Occupancy'
    }
});